// src/redux/empresaSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  empresas: [],        // Organizations from UAU
  empresaActiva: null, // Selected organization
  certificados: [],
  loading: false,
  error: null
};

export const empresaSlice = createSlice({
  name: 'empresa',
  initialState,
  reducers: {
    setEmpresas: (state, action) => {
      state.empresas = action.payload;
    },
    setEmpresaActiva: (state, action) => {
      state.empresaActiva = action.payload;
      if (action.payload) {
        localStorage.setItem('empresaActiva', JSON.stringify(action.payload));
      } else {
        localStorage.removeItem('empresaActiva');
      }
    },
    setCertificados: (state, action) => {
      state.certificados = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    addCertificado: (state, action) => {
      state.certificados.push(action.payload);
    },
    removeCertificado: (state, action) => {
      state.certificados = state.certificados.filter(cert => cert.id !== action.payload);
    },
    initEmpresaActiva: (state) => {
      const stored = localStorage.getItem('empresaActiva');
      if (stored) {
        try {
          state.empresaActiva = JSON.parse(stored);
        } catch (e) {
          console.error("Error al cargar empresa activa:", e);
          localStorage.removeItem('empresaActiva');
        }
      }
    }
  }
});

export const {
  setEmpresas, setEmpresaActiva, setCertificados,
  setLoading, setError, addCertificado, removeCertificado,
  initEmpresaActiva
} = empresaSlice.actions;

export default empresaSlice.reducer;
